import React, { useEffect, useState } from 'react';
import {  Table,  TableHeader,  TableBody,  TableColumn,  TableRow,  TableCell} from "@nextui-org/table";
import { other_uri, shop_uri } from '../../../utils/url';
import axios from 'axios';
import { Input, Spinner } from '@nextui-org/react';
import { MdOutlineDelete } from "react-icons/md";
import {toast} from "react-toastify";
import CreateGallery from './Modals/createGallery';
import AddImage from './Modals/addImage';
import { ODON_MEDALI, TYPE, TYPES } from '../../../utils/types';
import Paginations from '../../../components/Pagination';


const Odon = () => {
    const [data, setData] = useState([]);
    const [username, setUsername] = useState("");
    const [pagination, setPagination] = useState({limit:20, all:'', totalPage:''});
    const [page, setPage] = useState(1);
    const [load, setLoad] = useState(false);
    const [loaddel, setLoaddel] = useState(false);

    function callback(){
      Get();
    }

    const Get = async () => {
        setLoad(true);
        try{
          const res = await axios.get(other_uri+`/odon/admin?title=${username}&page=${page}&limit=${pagination.limit}`);
          setPagination({...pagination, all:res.data.all, totalPage:res.data.totalPage});
          setData(res.data.data);
          setLoad(false);
        }catch(err){
          setLoad(false);
          console.log(err);
        }
      }
    
      useEffect(() => {
        Get();
      }, []);
    
      const handleKeySub = (event) => {
        if (event.key === 'Enter') {
          Get();
        }
      };
    
      const changePage = (page) => {
        setPage(page);
      };

      const Delete = async (e) => {
        setLoaddel(true);
        try{
          const res = await axios.delete(other_uri+`/gallery?id=${e}`);
          if(res.status === 200){
            toast.success("Амжилттай устгалаа");
            callback();
          }
          setLoaddel(false);
        }catch(err){
          setLoaddel(false);
          console.log(err);
        }
      }

  return (
    <div>
        <div className='bg-white p-4 rounded-lg'>
            <div className='flex justify-between items-center'>
                <h1>Цол зэрэгийн хүсэлт</h1>
                <CreateGallery callback={callback}/>
            </div>
        </div>
        <div className='mt-2 bg-white rounded-xl p-4'>
            <Input size='xs' onKeyDown={handleKeySub} value={username} onChange={(e)=> setUsername(e.target.value)} className='mb-4 rounded-full' placeholder='Хайлт хийх' rounded="full"/>
            <Table aria-label="Example static collection table">
                <TableHeader>
                    <TableColumn>Шагналын нэр</TableColumn>
                    <TableColumn>Утасны дугаар</TableColumn>
                    <TableColumn>Файл</TableColumn>
                    <TableColumn>Үүсгэсэн огноо</TableColumn>
                    <TableColumn></TableColumn>
                </TableHeader>
                <TableBody>
                  {
                    data.map((it, index) => {
                      const a = ODON_MEDALI.find((i) => i.value == it.type);
                        return(
                            <TableRow key={index}>
                                <TableCell>
                                  {a.name}
                                </TableCell>
                                <TableCell>{it.phone}</TableCell>
                                <TableCell>
                                  <a target='_blank' href={it.file} className='bg-gray-200 rounded-md text-xs p-1'>
                                    Файл татах
                                  </a>
                                </TableCell>
                                <TableCell>{it.created_date}</TableCell>
                                <TableCell className='flex items-center gap-2'>
                                  {
                                    it.status === TYPES.REQUESTED &&
                                    <h1 className='bg-green-600 text-white rounded-md p-1 shadow-md text-xs '>
                                      <span className=''>Шинэ</span>
                                    </h1>
                                  }
                                  {
                                    it.status === TYPES.APPROVED &&
                                    <h1 className='bg-green-600 text-white rounded-md p-1 shadow-md text-xs '>
                                      <span className=''>Шийдвэрлэгдсэн</span>
                                    </h1>
                                  }
                                  {/* {
                                    loaddel ?
                                    <Spinner/>
                                    :
                                    <MdOutlineDelete onClick={()=>Delete(it.id)} color='red' size={20}/>
                                  }
                                  <AddImage it={it}/> */}
                                </TableCell>
                            </TableRow>
                        )
                    })
                  }
                </TableBody>
            </Table>
            <Paginations initialPage={page} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
        </div>
    </div>
  )
}

export default Odon